export default __webpack_public_path__ + "static/soc-bw-2b0f0d0f26ccf42a7f1d429506bb9ff4.png";